import { render, staticRenderFns } from "./SPRPill.vue?vue&type=template&id=7636bcaf"
import script from "./SPRPill.vue?vue&type=script&lang=js"
export * from "./SPRPill.vue?vue&type=script&lang=js"
import style0 from "./SPRPill.vue?vue&type=style&index=0&id=7636bcaf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports